import histotyDbService from "@/utils/historyDB";
import { pick } from "lodash";

export async function getHistoryList({ type = "pin", max, limit = 20 }) {
  return histotyDbService.getList({ type, lastRecord: max, limit });
}

export async function delHistory({ type, target }) {
  return histotyDbService.del({ type, record: target });
}

export async function delHistoryAll(type) {
  return histotyDbService.delAll(type);
}

export async function addHistory({ type, record, id }) {
  const filterRecord = pick(record, ["file", "pin_id", "file_id", "raw_text"]);
  return histotyDbService.add({ type, record: filterRecord, id: +id });
}
